<template>
    <div id="aprication">
        <div class="headerp-div">
            <div class="header-div0">
                <el-breadcrumb separator-class="el-icon-arrow-right">
                    <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                    <el-breadcrumb-item :key="crumbs" v-for="crumbs in $crumbsList()">{{crumbs}}</el-breadcrumb-item>
                </el-breadcrumb>
            </div>
            <div class="header-div1" style="text-align: right">
                <div style="float: right">
                    <el-button size="mini" v-if="$hasPerm('business:reportItem:add')" @click="handleAdd()"
                               style=";background-color:#16E3A1;color: white">新增<i class="el-icon-plus"></i></el-button>
                </div>
                <div style="float: right">
                    <el-button size="mini" @click="handleFind()" style=";background-color:#409EFF;color: white;">查询<i
                            class="el-icon-search"></i></el-button>
                </div>
                <div style="float: right">
                    <el-input
                            class="queryInput"
                            size="mini"
                            placeholder="请输入计项代码"
                            v-model="itemCode"
                            clearable>
                    </el-input>
                </div>
                <div style="float: right">
                    <el-input
                            class="queryInput"
                            size="mini"
                            placeholder="请输入计项名称"
                            v-model="itemName"
                            clearable>
                    </el-input>
                </div>
                <div style="float: right">
                    <el-select style="width: 100%;padding-right: 5px;" size="mini" v-model="tjPatternCode" placeholder="统计方式" clearable >
                        <el-option label="库表统计" value="1"/>
                        <el-option label="算数统计" value="2"/>
                    </el-select>
                </div>
                <div style="float: right">
                    <el-select style="width: 100%;padding-right: 5px;" size="mini" v-model="reportCode" placeholder="报表类型" clearable >
                        <el-option value="report_zcfzb" label="资产负载表"/>
                        <el-option value="report_lrb" label="利润表"/>
                        <el-option value="report_xjllb" label="现金流量表"/>
                    </el-select>
                </div>
            </div>
        </div>
        <el-table :data="tableData" size="mini" border style="width: 100%">
            <el-table-column prop="reportName" width="160" label="报表名称"></el-table-column>
            <!--<el-table-column prop="reportCode" label="报表代码"></el-table-column>-->
            <el-table-column prop="tjNumber" label="统计编号"></el-table-column>
            <el-table-column prop="itemName" label="统计项名称" width="390px">
                <template slot-scope="scope">
                    <span v-if="scope.row.tjPatternCode=='2' || scope.row.tjPatternCode == ''" style="font-weight: bold">{{scope.row.itemName}}</span>
                    <span v-else>{{scope.row.itemName}}</span>
                </template>
            </el-table-column>
            <el-table-column prop="itemCode" label="统计项代码"></el-table-column>
            <el-table-column prop="tjPatternName" label="统计方式"></el-table-column>
            <el-table-column prop="rowNum" label="行序号"></el-table-column>
            <el-table-column prop="colNum" label="列序号"></el-table-column>
            <el-table-column prop="leftPx" label="左边距"></el-table-column>
            <el-table-column label="设置统计公式" width="126px" v-if="$hasPerm('business:reportItem:edit')">
                <template slot-scope="scope">
                    <el-button size="mini" style="color: #3cbaff" v-if="$hasPerm('business:reportItem:edit')"
                               @click="handleFormula(scope.row)">编辑公式<i class="el-icon-edit"></i></el-button>
                </template>
            </el-table-column>
            <el-table-column label="操作" width="200" v-if="$hasPerm('business:reportItem:edit,business:reportItem:remove')">
                <template slot-scope="scope">
                    <el-button size="mini" style="margin-right: 10px;color: #3cbaff" v-if="$hasPerm('business:reportItem:edit')"
                               @click="handleEdit(scope.$index, scope.row)">编辑<i class="el-icon-edit"></i></el-button>
                    <el-popconfirm title="确定删除吗？" @onConfirm="handleDelete(scope.$index, scope.row)">
                        <el-button size="mini" slot="reference" v-if="$hasPerm('business:reportItem:remove')"
                                   type="danger">删除<i class="el-icon-delete"></i></el-button>
                    </el-popconfirm>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination
                style="margin-top: 5px;"
                background
                layout="total, sizes, prev, pager, next, jumper"
                :total="total"
                :page-sizes="[10, 20, 30, 40, 50, 60, 70, 80, 90, 100]"
                :page-size="pageSize"
                :current-page="currentPage"
                @current-change="handleCurrentChange"
                @size-change="handleSizeChange"
        ></el-pagination>
        <edit v-if="editVisible" ref="edit" @handleCurrentChange="handleCurrentChange"></edit>
        <formula v-if="formulaVisible" ref="formula"></formula>
        <formula2 v-if="formulaVisible2" ref="formula2"></formula2>
    </div>
</template>
<script>
    import Edit from './edit'
    import Formula from '../reportStatisticalFormula/list'
    import Formula2 from '../reportStatisticalFormula/list2'

    export default {
        name: 'reportItemList',
        components: {
            Edit,
            Formula,
            Formula2
        },
        data() {
            return {
                currentPage: 1, //初始页
                pageSize: 10, //    每页的数据
                total: 0,
                offset: 0,
                tableData: [],
                itemName: '',
                itemCode: '',
                reportCode: 'report_zcfzb',
                tjPatternCode: '',
                editVisible: false,
                formulaVisible: false,
                formulaVisible2: false
            }
        },
        methods: {
            handleCurrentChange(cPage) {
                this.currentPage = cPage;
                this.offset = (cPage - 1) * this.pageSize;
                this.$httpTAG({
                    url: this.$httpTAG.adornUrl('/business/reportItem/list'),
                    method: 'get',
                    params: {
                        'offset': this.offset,
                        'limit': this.pageSize,
                        'itemName': this.itemName,
                        'itemCode': this.itemCode,
                        'reportCode': this.reportCode,
                        'tjPatternCode': this.tjPatternCode
                    }
                }).then(r => {
                    this.tableData = r.data.data.rows;
                    this.total = r.data.data.total;
                }).finally(r => {
                })

            },
            handleSizeChange(val) {
                this.pageSize = val;
                this.handleCurrentChange(1);
            },
            dataFormat: function (row, column) {
                let val = row[column.property];
                if (val == 1) {
                    return '是'
                }
                if (val == 0) {
                    return '否'
                }
                return val;
            },
            handleFind() {
                this.handleCurrentChange(1);
            },
            handleFormula(row) {
                //统计方式代码 1:库表统计 2:算数统计
                if(row.tjPatternCode=='1'){
                    this.formulaVisible = true;
                    let itemId = row.id;
                    let itemName = row.itemName;
                    let reportCode = row.reportCode;
                    this.$nextTick(() => {
                        this.$refs.formula.int(itemId,reportCode,itemName, null);
                    })
                }else{
                    this.formulaVisible2 = true;
                    let itemId = row.id;
                    let itemName = row.itemName;
                    let reportCode = row.reportCode;
                    this.$nextTick(() => {
                        this.$refs.formula2.int(itemId,reportCode,itemName);
                    })
                }

            },
            handleAdd() {
                this.editVisible = true;
                this.$nextTick(() => {
                    this.$refs.edit.int("add",this.currentPage);
                })
            },
            handleEdit(index, row) {
                let id = row.id;
                this.editVisible = true;
                this.$nextTick(() => {
                    this.$refs.edit.int(id,this.currentPage);
                })
            },
            handleDelete(index, row) {
                let id = row.id;

                this.$httpTAG({
                    url: this.$httpTAG.adornUrl('/business/reportItem/remove'),
                    method: 'post',
                    data: this.$httpTAG.adornData({
                        'id': id
                    })
                }).then(res => {
                    if (res.data.code == 0) {
                        this.$notify({
                            title: '操作成功！',
                            type: 'success',
                            offset: 600
                        });
                        this.handleCurrentChange(this.currentPage);
                    } else {
                        this.$message({ // 失败
                            type: 'error',
                            message: res.data.msg
                        })
                    }
                }).finally(r => {
                })
            }
        },
        created: function () {
            this.handleCurrentChange(this.currentPage);
        }
    }
</script>
<style scoped>
    .header-div0 {
        margin-bottom: 5px;
        float: left;
        width: 20%;
    }

    .header-div1 {
        margin-bottom: 5px;
        float: left;
        width: 80%;
    }

    .queryInput >>> .el-input__inner {
        border-radius: 0px;
        width: 180px;
        margin-right: 5px;
    }
</style>